
/**
 * @typedef {'px' | 'em' | 'rem' | '%' | 'auto'} CssUnit
 */

/**
 * @param {object} props
 * @param {CssUnit} props.unit - Current unit
 * @param {(unit: CssUnit) => void} props.onChange - Change callback
 * @param {CssUnit[]} [props.units] - Which units to show (defaults to ['px', 'em', '%'])
 * @param {string} [props.className] - Additional class name(s) for the select element
 * @returns 
 */
export const CssUnitSelect = ({ unit, onChange, units = ['px', 'em', '%', 'auto'], className = '' }) => {
    return (
        <select
            className={`css-unit-select ${className}`.trim()}
            value={unit ?? 'px'}
            onChange={(e) =>
                onChange(/** @type {CssUnit} */ (e.target.value))
            }
        >
            {units.map((u) => (
                <option key={u} value={u}>{u}</option>
            ))}
        </select>
    )
}
